import React from "react";
import "./Checkout.css";
import Subtotal from "./Subtotal";
import { useStateValue } from "./StateProvider";
import CheckoutProduct from "./CheckoutProduct";
import FlipMove from "react-flip-move";

function Checkout() {
    const [{ basket, user }, dispatch] = useStateValue();


    const email = user?.email;
    const username = /[^@]*/.exec(email)[0];


    return (
        <div className="checkout">
            <img
                className="checkout__ad"
                // src="https://images-na.ssl-images-amazon.com/images/G/01/AmazonExports/Fuji/2020/May/Hero/Fuji_TallHero_45M_v2_1x._CB432458380_.jpg"
                src="https://images-na.ssl-images-amazon.com/images/G/02/UK_CCMP/TM/OCC_Amazon1._CB423492668_.jpg"
                alt=""
            />
            <div className="checkout__body">

                <div className="checkout__left">

                    {basket?.length === 0 ? (
                        <div className="checkout__empty">
                            <img className="checkout__emptyImage" src="https://m.media-amazon.com/images/G/01/cart/empty/kettle-desaturated._CB445243794_.svg" alt="" />
                            <div className="checkout__emptyText">

                                <h2 className="checkout__emptyTitle"> Hi, {!user ? 'Customer' : username}. Your Armazon Basket is Empty.</h2>
                                <p className="checkout__emptyInfo">Your shopping cart is empty. To buy any items, go ahead to the item and click "Add to Basket". Thanks for shopping with us. </p>
                            </div>
                        </div>
                    ) : (
                            <div className="checkout__list">
                                <h2 className="checkout__title"> Hello, {!user ? 'Customer' : username}.

                                  Your Armazon Basket has the following items:</h2>
                                <FlipMove leaveAnimation="elevator">

                                    {basket.map(item => (
                                        <CheckoutProduct
                                            key={parseInt(item.id) * Math.random()}
                                            id={item.id}
                                            title={item.title}
                                            image={item.image}
                                            price={item.price}
                                            rating={item.rating}
                                        />
                                    ))}
                                </FlipMove>
                            </div>


                        )}
                    <div>

                        {/* <h3>Hello, */}
                        {/* {user?.email} */}
                        {/* </h3> */}
                        {/* <h2 className="checkout__title">Your shopping Basket</h2> */}

                    </div>
                </div>

                {basket.length > 0 && (
                    <div className="checkout__right">
                        <Subtotal />
                    </div>
                )}

            </div>
        </div >
    );
}

export default Checkout;
